<template>
    <div @mouseover="hovered=true" @mouseout="hovered=false" @click="click">
        <slot name="cell" :field="field" :meta="meta">
            {{ meta.label || field }}<!--
            //--><open-icon
                v-if="meta.sort!==false"
                glyph="arrow-down"
                :class="{'text-gray': meta.sort !== 'desc'}"
            /><!--
            //--><open-icon
                v-if="meta.sort!==false"
                glyph="arrow-up"
                :class="{'text-gray': meta.sort !== 'asc'}"
            />
        </slot>
    </div>
</template>

<script type="text/javascript">
import { OpenIcon } from "../../nibnut/components"

export default {
    components: {
        OpenIcon
    },
    methods: {
        header_glyph (sort) {
            if(this.hovered) {
                if(sort && sort.match(/^asc/i)) return "sort-descending"
                return "sort-ascending"
            }
            if(sort && sort.match(/^desc/i)) return "sort-descending"
            return "sort-ascending"
        },
        click () {
            this.$emit("click", this.field, this.meta)
        }
    },
    props: {
        field: {
            type: String,
            required: true
        },
        meta: {
            type: Object,
            required: true
        }
    },
    data () {
        return {
            hovered: false
        }
    }
}
</script>
